



































































































































import { GREEN, RED, YELLOW } from "@/resources/constants/busyReasons";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import { Component, Watch } from "vue-property-decorator";
import { ClickOutsideDirective } from "../../../../helpers/directives/clickOutside.directive";
@Component({
  name: "new-chat-component",
  directives: { ClickOutsideDirective },
})
export default class NewChatComponent extends mixins(NotificationEvent) {
  users = [];
  sound = "NO_SOUND";
  message = "";
  loader = false;
  loading = false;
  userSelector = 0;
  searchUserName = "";
  userLoader = false;
  searchTimeOut = null;
  userSelected = null;
  page = 1;
  lastPage = 1;
  lastScroll = 0;
  get active(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenNewMessage"];
  }
  set active(e: boolean) {
    this.$store.dispatch("FloatMenuStore/setOpenNewMessageAction", e);
  }
  get localUser() {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  beforeUnmount() {
    const userList = document.getElementById("users-in-search");
    userList.removeEventListener("scroll", (e) => {
      // do nothing
    });
  }
  async sendMessage(): Promise<void> {
    if (this.message !== "") {
      await this.$store.dispatch("ChatStore/sendNewMessageAction", {
        userId: this.userSelected.superSpaceUser.id,
        data: {
          chatMessage: this.message,
          chatMessageType: TYPES_MESSAGES.NORMAL,
        },
      });
      this.message = "";
      setTimeout(() => {
        this.onSuccess(
          this.$i18n.t("notifications.titles.success"),
          this.$i18n.t("notifications.newMessage.sendNewMessage")
        );
        this.openUserChat();
      }, 1000);
    }
  }
  async openUserChat(): Promise<void> {
    await this.$store.dispatch("ChatStore/setMessagesAction", []);
    await this.$store.dispatch("ChatStore/setUserChatAction", {
      superSpaceUser: this.userSelected.superSpaceUser,
      user: this.userSelected.superSpaceUser.user,
    });
    await this.$store.dispatch(
      "ChatStore/setChatTypeAction",
      CHAT_TYPE.ONE_TO_ONE
    );
    await this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
      id: this.userSelected.superSpaceUser.id,
      type: CHAT_TYPE.ONE_TO_ONE,
    });
    this.$emit("go-to-chat");
  }

  @Watch("searchUserName")
  searchUser() {
    if (this.searchUserName === "") {
      this.users = [];
      this.page = 1;
      this.lastPage = 1;
      this.lastScroll = 0;
      return;
    }
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.$store.dispatch("SpaceStore/searchSpaceUserAndNotAddAction", {
        superSpaceId: space.superSpace.id,
        name: this.searchUserName,
        page: null,
        callback: (response) => {
          this.userLoader = false;
          const user = this.$store.getters["UserStore/getSpaceUser"];
          const data = response.data.filter(
            (a) => a.user.id !== user.superSpaceUser.user.id
          );
          if (response.headers["pagination-last-page"] > 1) {
            this.page += 1;
            this.lastPage = parseInt(response.headers["pagination-last-page"]);
          }
          this.users = data;
          this.loading = false;
          setTimeout(() => {
            this.onScrollEvent();
          }, 1000);
        },
      });
    }, 1000);
  }
  onScrollSearch() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (this.lastPage < this.page) {
      return;
    }

    this.loading = true;
    this.$store.dispatch("SpaceStore/searchSpaceUserAndNotAddAction", {
      spaceId: space.superSpace.id,
      name: this.searchUserName,
      page: this.page,
      callback: (response) => {
        this.userLoader = false;
        const user = this.$store.getters["UserStore/getSpaceUser"];
        const data = response.data.filter(
          (a) => a.user.id !== user.superSpaceUser.user.id
        );
        this.page += 1;
        this.lastPage = parseInt(response.headers["pagination-last-page"]);
        this.users = [...this.users, ...data];
        this.loading = false;
      },
    });
  }
  close() {
    this.searchUserName = "";
    this.lastScroll = 0;
    this.users = [];
  }
  selectUser(user) {
    this.userSelected = user;
    this.searchUserName = "";
    this.users = [];
  }
  setAvatarColor(color: string): string {
    switch (color) {
      case GREEN.type:
        return GREEN.color;
      case RED.type:
        return RED.color;
      case YELLOW.type:
        return YELLOW.color;
      default:
        return RED.color;
    }
  }
  onScrollEvent() {
    const userList = document.getElementById("users-in-search");
    userList.addEventListener("scroll", () => {
      const a = userList.scrollTop;
      const b = userList.scrollHeight - userList.clientHeight;
      if (this.lastScroll < 0.6 && a / b > 0.6) {
        this.onScrollSearch();
      }

      this.lastScroll = a / b;
    });
  }
}
